import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  height: 18px;
  width: auto;
  min-width: 18px;
  font-size: 10px;
  font-weight: bold;
  background: #B9B9B9;
  color: #FFFFFF;
  margin-left: 5px;
`

const StyledCollapseLink = styled(IconLink)`
  padding-left: 25px;
`

const CollapseLink = ({ count, active, onClick, tooltip, portalId }) => {
  const renderPortal = (component) => {
    const el = document.getElementById(portalId || 'main-header-left-placeholder')
    if (!el) {
      return null
    }

    return ReactDOM.createPortal(component, el)
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClick()
    }
  }

  const tooltipId = 'main-header-collapse-tooltip-id'

  return renderPortal(
    <StyledCollapseLink
      onClick={onClick}
      iconName='icon-filter'
      active={active}
      data-tooltip-content={tooltip}
      data-tooltip-id={tooltipId}
      tabIndex={0}
      onKeyDown={onKeyDown}
    >
      {count > 0 && (
        <>
          <Circle>{count}</Circle>
          <Tooltip id={tooltipId} />
        </>
      )}
    </StyledCollapseLink>
  )
}

CollapseLink.propTypes = {
  count: PropTypes.number,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  portalId: PropTypes.string,
}

export default CollapseLink
